import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { CURRENCY_SYMBOL_MAP } from '../utils/constants';
import CurrencyInput from 'react-currency-input-field';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPiggyBank } from '@fortawesome/free-solid-svg-icons';

const SavingGoalCarousel = ({ slides, options, onUpdate }) => {
  const [emblaRef] = useEmblaCarousel(options);

  const handleUpdate = async (id, newSavedAmount) => {
    try {
      await axios.put(`${process.env.REACT_APP_API_URL}/saving-goals/${id}`, { savedAmount: newSavedAmount });
    } catch (error) {
      console.error('Error updating saving goal:', error);
    }
  };

  return (
    <section className="w-full">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex touch-pan-y -ml-4 py-2">
          {slides.map((goal) => (
            <div className="flex-grow-0 flex-shrink-0 w-full min-w-0 pl-4 relative" key={goal._id}>
              <div className="bg-white dark:bg-dark-surface border border-gray-100 dark:border-gray-700 rounded-2xl p-4 shadow-sm h-full flex flex-col transition-colors">
                <div className="flex justify-between items-start mb-3">
                  <h3 className="text-lg font-bold text-gray-800 dark:text-white line-clamp-1">{goal.name}</h3>
                  <span className="text-xs font-medium px-2 py-1 bg-primary-50 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 rounded-full">
                    {Math.round((goal.savedAmount / goal.goal) * 100)}%
                  </span>
                </div>
                
                <div className="w-full aspect-video mb-3 rounded-xl overflow-hidden border border-gray-100 dark:border-gray-700">
                  {goal.imageUrl ? (
                    <img src={goal.imageUrl} alt={goal.name} className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full bg-gradient-to-br from-primary-100 to-primary-200 dark:from-primary-900/40 dark:to-primary-800/40 flex items-center justify-center">
                      <FontAwesomeIcon icon={faPiggyBank} className="text-4xl text-primary-400 dark:text-primary-500" />
                    </div>
                  )}
                </div>

                <div className="mt-auto space-y-3">
                  <div className="w-full bg-gray-100 dark:bg-gray-700 rounded-full h-3 overflow-hidden transition-colors">
                    <div
                      className={`h-full rounded-full transition-all duration-500 ${
                        goal.savedAmount / goal.goal * 100 < 33 ? 'bg-red-500' : 
                        goal.savedAmount / goal.goal * 100 < 66 ? 'bg-orange-500' : 'bg-green-500'
                      }`}
                      style={{ width: `${Math.min((goal.savedAmount / goal.goal) * 100, 100)}%` }}
                    ></div>
                  </div>


                  <div className="flex justify-between items-center text-sm">
                    <div className="flex items-center bg-gray-50 dark:bg-gray-700 rounded-lg px-2 py-1 border border-gray-100 dark:border-gray-600 transition-colors">
                      <CurrencyInput
                        value={goal.savedAmount}
                        onValueChange={(value) => {
                          const newGoal = { ...goal, savedAmount: value };
                          onUpdate(newGoal);
                        }}
                        onBlur={(e) => handleUpdate(goal._id, parseFloat(e.target.value.replace(/[^0-9.-]+/g, "")))}
                        className="w-20 !bg-transparent border-none outline-none text-gray-900 dark:text-white font-semibold focus:ring-0 p-0 text-right"
                        decimalsLimit={2}
                      />
                      <span className="ml-1 text-gray-500 dark:text-gray-400 font-medium">{CURRENCY_SYMBOL_MAP[goal.currency]}</span>
                    </div>
                    <span className="text-gray-400 dark:text-gray-500 font-medium">/ {goal.goal}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default SavingGoalCarousel
